import React, { useState, useEffect, useMemo } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, Alert } from 'reactstrap';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { addNewArticle, getArticleList } from '../../../../slices/thunks';

const ArticleForm = ({ dataNormative, handleToggleModalArticle }) => {
    const dispatch = useDispatch();
    const [selectedNormative, handleNormativeSelected] = useState(null);

    const selectorArticle = createSelector(
        state => state.Article,
        data => ({
            dataList: data.articleList,
            isLoadingList: data.isLoadingList,
            isArticleSuccess: data.isArticleSuccess,
            error: data.error,
            isAdding: data.isAdding,
            isAdded: data.isAdded,
            isAddError: data.isAddError,
            isUpdating: data.isUpdating,
            isUpdated: data.isUpdated,
            isUpdateError: data.isUpdateError,
            isDeleting: data.isDeleting,
            isDeleted: data.isDeleted,
            isDeleteError: data.isDeleteError,
        })
    );

    const { dataList, isLoadingList, isAdding, isUpdating } = useSelector(selectorArticle);

    useEffect(() => {
        if (dataNormative) {
            dispatch(getArticleList({ normative_id: dataNormative._id }));
        }
    }, []);



    const [isReportableCheck, setIsReportableCheck] = useState(false);


    const handleIsReportableCheckboxChange = () => {
        setIsReportableCheck(!isReportableCheck);
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            normative_id: dataNormative._id,
            // title: values.title,
            // paragraph: values.paragraph,
            // article: values.article,
        },
        validationSchema: Yup.object({
            title: Yup.string().required('Campo requerido'),
            paragraph: Yup.string().required('Campo requerido'),
            article: Yup.string().required('Campo requerido'),
        }),
        onSubmit: async (values) => {
            const payloadArticle = {
                normative_id: values.normative_id,
                title: values.title,
                paragraph: values.paragraph,
                article: values.article,
            };


            // if (isEdit) {
            //     await dispatch(updateArticle({ ...payloadArticle, _id: dataArticle._id }));
            // } else {
            let article = await dispatch(addNewArticle(payloadArticle));
            //     payloadActivity['article_id'] = article.payload._id
            //     await dispatch(addNewActivityTemplateItem(payloadActivity));
            // }
        },
    });



    // Delete Data
    const handleClickDelete = article => {
        setDataArticle(article);
        setModalDelete(true);
    };

    // Update Data
    const handleClickEdit = article => {
        setDataArticle(article);
        handleToggleModalArticle();
    };

    const columns = useMemo(
        () => [
            {
                header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
                accessorKey: 'article_form',
                columnDefType: 'display',
                 width: '5%',
                Cell: cellProps => {
                    return (
                        <React.Fragment>
                            <div className='d-flex'>
                                <div className='flex-shrink-0'>
                                    <ul className='list-inline mb-0'>
                                        <li className='list-inline-item'>
                                            <Link
                                                to='#'
                                                onClick={() => {
                                                    const articleData =
                                                        cellProps.row.original;
                                                    setIsEdit(true);
                                                    handleClickEdit(articleData);
                                                }}
                                            >
                                                <i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
                                            </Link>
                                        </li>
                                        <li className='list-inline-item'>
                                            <Link
                                                to='#'
                                                className='remove-item-btn'
                                                onClick={() => {
                                                    const articleData =
                                                        cellProps.row.original;
                                                    handleClickDelete(articleData);
                                                }}
                                            >
                                                <i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                },
            },
            {
                header: 'Artículo', accessorKey: 'article',  width: '30%',
                Cell: ({ row }) => { return (<div className='no-nowrap'>{row.original.article}</div>); },
            },
            {
                header: 'Título', accessorKey: 'title',  width: '10%',
                Cell: ({ row }) => { return (<div className='no-nowrap'>{row.original.title}</div>); },
            },
            {
                header: 'Parrafo', accessorKey: 'paragraph',  width: '10%',
                Cell: ({ row }) => { return (<div className='no-nowrap'>{row.original.paragraph}</div>); },
            },
        ],
        [handleClickEdit]
    );


    return (
        <React.Fragment>

            <Form
                className='tablelist-form'
                onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                }}
            >
                <ModalBody>
                    <Row className='g-3'>
                        <Col lg={6}>
                            <Label for='title' className='form-label'>
                                Título
                            </Label>
                            <Input
                                name='title'
                                id='title'
                                className='form-control'
                                placeholder='Ingrese El título'
                                type='text'
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ''}
                                invalid={validation.touched.title && validation.errors.title ? true : false}
                            />
                            {validation.touched.title && validation.errors.title && (
                                <FormFeedback type='invalid'>
                                    {validation.errors.title}
                                </FormFeedback>
                            )}
                        </Col>
                        <Col lg={6}>
                            <Label for='paragraph' className='form-label'>
                                Párrafo
                            </Label>
                            <Input
                                name='paragraph'
                                id='paragraph'
                                className='form-control'
                                placeholder='Ingrese una página'
                                type='text'
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.paragraph || ''}
                                invalid={validation.touched.paragraph && validation.errors.paragraph ? true : false}
                            />
                            {validation.touched.paragraph && validation.errors.paragraph && (
                                <FormFeedback type='invalid'>
                                    {validation.errors.paragraph}
                                </FormFeedback>
                            )}
                        </Col>
                        <Col lg={12}>
                            <Label for='article' className='form-label'>
                                Artículo
                            </Label>
                            <Input
                                name='article'
                                id='article'
                                className='form-control'
                                placeholder='Ingrese el artículo'
                                type='textarea'
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.article || ''}
                                invalid={validation.touched.article && validation.errors.article ? true : false}
                            />
                            {validation.touched.article && validation.errors.article && (
                                <FormFeedback type='invalid'>
                                    {validation.errors.article}
                                </FormFeedback>
                            )}
                        </Col>

                        <Col lg={12}>
                            <Label for='article' className='form-label'>
                                Lista de Artículos
                            </Label>
                            <ODataGrid
                                columns={columns}
                                data={dataList || []}
                                isLoadingData={isLoadingList}
                            />
                        </Col>
                    </Row>
                </ModalBody>

                <div className='modal-footer'>
                    <div className='hstack gap-2 justify-content-end'>
                        <Button
                            type='button'
                            onClick={() => {
                                handleToggleModalArticle();
                            }} className='btn-danger btn-label'>
                            <i className="icon-x label-icon"></i>
                            Cancelar
                        </Button>
                        <button
                            type='submit'
                            className='btn btn-label btn-primary'
                            id='add-btn'
                            disabled={isAdding || isUpdating}
                        >
                            {isAdding || isUpdating ? (
                                <i className="label-icon"><Spinner size='sm' /></i>
                            ) : <i className="ri-save-3-line label-icon"></i>}
                            Actualizar
                        </button>
                    </div>
                </div>
            </Form>

        </React.Fragment>
    );
};

export default ArticleForm;
